<script>
import conTrack from 'gkConUI/con-track'
import utils from '@/utils'
import { mapState } from 'vuex'

export default {
  data () {
    return {
    }
  },
  components: {
    conTrack
  },
  props: [
    'id'
  ],
  computed: {
    ...mapState({
      config: 'config',
      topics: 'topics'
    }),
    track () {
      return this.topics[this.id] || { lectureIds: [] }
    }
  },
  updated () {
    if (this.track.speaker) {
      utils.weixinshare({
        imgUrl: this.track.speaker.avatar,
        title: this.track.topic + this.config.wechat_share.default_title
      })
    }
  },
  mounted () {
    if (this.track.speaker) {
      utils.weixinshare({
        imgUrl: this.track.speaker.avatar,
        title: this.track.topic + this.config.wechat_share.default_title
      })
    }
  },
  render () {
    return (<con-track {...{ props: { id: this.id } }}/>)
  }
}
</script>
